/**
 * Styles, extracted by the build into dist/styles/main.css. Font Awesome comes last: under webpack it
 * was injected as a <style> tag after main.css, so it must keep winning the same cascade ties.
 */
import '../styles/main.scss';
import 'font-awesome/css/font-awesome.css';

/** import external dependencies */
import Debug from 'debug'; // helpful -> http://smalljs.org/logging/debug/
import moment from 'moment-timezone';
import 'cookieconsent';

// The webpack build exposed moment as a global; scripts outside the bundle may rely on it.
window.moment = moment;

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import changePassword from './routes/change-password';
import createPassword from './routes/create-password';
import home from './routes/home';
import login from './routes/login';
import aboutUs from './routes/about';
import search from './routes/search';
import myAccount from './routes/my-account';
import profile from './routes/profile';
import single from './routes/single';
import portfolio from './routes/portfolio';

/**
 * This will enable/disable all console output by commenting it out, disabled by default
 */
// Debug.enable(`cig*`);
Debug.disable(`cig*`);

try {
	/**
	 * Populate Router instance with DOM routes
	 *
	 * --Portfolio-- The /portfolio route enqueues datatables.js because it includes a bunch of additional JS that could slow the site down otherwise
	 */
	const routes = new Router({
		common, // all pages
		changePassword,
		createPassword,
		home,
		login,
		aboutUs, // note the change from about-us to aboutUs
		search,
		myAccount,
		profile,
		single,
		portfolio, // all portfolio pages (will use JS to add a script tag for simple-datatables, because it was breaking webpack/bable)
	});

	/**
	 * Load Events
	 */
	document.addEventListener("DOMContentLoaded", () => {
		routes.loadEvents();
	});
} catch (err) {
	// Log full error object if debugging enabled
	Debug(`cig:error:sage:main`)(`Main JS Error: %s %o`, err.message, err);
}
